import { render } from "./MenuIcons.vue?vue&type=template&id=770c744c"
import script from "./MenuIcons.vue?vue&type=script&lang=js"
export * from "./MenuIcons.vue?vue&type=script&lang=js"
script.render = render

export default script